export enum Theme {
  // Space = 'space',
  Auto = 'auto',
  Dark = 'dark',
  Light = 'light',
  // Emerald = 'emerald',
  // Purple = 'purple',
  // Brown = 'brown',
}
